/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-21 09:48:38
 * @LastEditTime: 2019-08-21 10:45:50
 * @LastEditors: Please set LastEditors
 */
const getters = {

  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  language: state => state.user.language,
  languageName: state => state.user.languageName,
  isDirection: state => state.user.isDirection,
  isApp: state => state.user.isApp,
  user:state=>state.user.user,
  session_id:state=>state.user.session_id,
  page_session_id: state => state.user.page_session_id,
  trigger: state=>state.user.trigger,
  languageList: state=>state.user.languageList
  // permission_routers: state => state.permission.routers,

}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js